<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>

<script>
  import internalPartner from "./internalPartner.vue";
  import externalPartner from "./externalPartner.vue";
  let tabBox = {
    '内部合伙人': {property: 'internalPartner'},
    '外部合伙人': {property: 'externalPartner'},
   
  }
  export default {
    name: "add",
    components: {
      internalPartner,
      externalPartner
    },
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName: ""
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "internalPartner";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
